import { CdkScrollable } from '@angular/cdk/scrolling';
import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';

@Component({
  selector: 'app-before-close',
  templateUrl: './before-close.component.html',
  styleUrls: ['./before-close.component.scss'],
  imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatButton, MatDialogClose]
})
export class BeforeCloseComponent {
  data = inject(MAT_DIALOG_DATA);
  private location = inject(Location);

  no() {
    this.location.back();
  }
}
